module.exports = __webpack_public_path__ + "img/ke.6ef4429f.svg";